export default __webpack_public_path__ + "static/media/diesel.e39d5136.svg";